import * as T from './rootDetectionTypes';

export const checkRootDetectionRequest = () => ({
  type: T.CHECK_ROOT_DETECTION_REQUEST as typeof T.CHECK_ROOT_DETECTION_REQUEST,
});

export const checkRootDetectionSuccess = (isHighRisk: boolean) => ({
  type: T.CHECK_ROOT_DETECTION_SUCCESS as typeof T.CHECK_ROOT_DETECTION_SUCCESS,
  payload: isHighRisk,
});

export const checkRootDetectionFailure = (error: string) => ({
  type: T.CHECK_ROOT_DETECTION_FAILURE as typeof T.CHECK_ROOT_DETECTION_FAILURE,
  payload: error,
});
